import { Action, createReducer, on } from '@ngrx/store';

import { CartAdditionalFieldsState } from '@app-modules/cart/store/cart-additional-fields-state.type';
import { CartAdditionalFieldsActions } from '@app-modules/cart/store/cart-additional-fields.actions';
import { cartAdditionalFieldsMapper, entriesValuesMapper } from '@app-modules/cart/store/cart-additional-fields.mapper';

const initialState: CartAdditionalFieldsState = {
  entriesValues: [],
  expanded: false,
  fields: [],
  isOneShippingDelivery: false,
  selectedEntries: []
};

const reducer = createReducer(
  initialState,
  on(
    CartAdditionalFieldsActions.initializeFields,
    (state, { payload: { additionalFields, entries, completeDelivery } }): CartAdditionalFieldsState => {
      const fields = cartAdditionalFieldsMapper(additionalFields);
      const isOneShippingDelivery = completeDelivery ?? false;
      const entriesValues = entriesValuesMapper(fields, entries);
      const expanded = entriesValues.some((entry) => Object.values(entry).some((value) => !!value));
      return { ...state, fields, entriesValues, expanded, isOneShippingDelivery };
    }
  ),
  on(
    CartAdditionalFieldsActions.toggleFieldsVisibility,
    (state, { expanded }): CartAdditionalFieldsState => ({
      ...state,
      expanded
    })
  ),
  on(
    CartAdditionalFieldsActions.toggleOneShippingDelivery,
    (state, { isOneShippingDelivery }): CartAdditionalFieldsState => ({
      ...state,
      isOneShippingDelivery
    })
  ),
  on(
    CartAdditionalFieldsActions.updateEntryValue,
    (state, { payload: { entryNumber, label, value } }): CartAdditionalFieldsState => {
      const entryValues = { ...(state.entriesValues[entryNumber] ?? {}), [label]: value };
      const entriesValues = [...state.entriesValues];
      entriesValues[entryNumber] = entryValues;
      return { ...state, entriesValues };
    }
  ),
  on(
    CartAdditionalFieldsActions.removeEntryValues,
    (state, { entryNumber }): CartAdditionalFieldsState => ({
      ...state,
      entriesValues: state.entriesValues.filter((_, index) => index !== entryNumber)
    })
  ),
  on(
    CartAdditionalFieldsActions.clearEntriesValues,
    (state): CartAdditionalFieldsState => ({
      ...state,
      entriesValues: []
    })
  ),
  on(
    CartAdditionalFieldsActions.selectAllEntries,
    (state, { selectedEntries }): CartAdditionalFieldsState => ({
      ...state,
      selectedEntries
    })
  ),
  on(
    CartAdditionalFieldsActions.unSelectAllEntries,
    (state): CartAdditionalFieldsState => ({
      ...state,
      selectedEntries: []
    })
  ),
  on(
    CartAdditionalFieldsActions.selectEntry,
    (state, { entryNumber }): CartAdditionalFieldsState => ({
      ...state,
      selectedEntries: [...state.selectedEntries, entryNumber]
    })
  ),
  on(
    CartAdditionalFieldsActions.unselectEntry,
    (state, { entryNumber }): CartAdditionalFieldsState => ({
      ...state,
      selectedEntries: state.selectedEntries.filter((entry) => entry !== entryNumber)
    })
  ),
  on(CartAdditionalFieldsActions.resetFields, (): CartAdditionalFieldsState => ({ ...initialState }))
);

export const cartAdditionalFieldsReducers = (
  state: CartAdditionalFieldsState,
  action: Action
): CartAdditionalFieldsState => reducer(state, action);
